/**
 * PATH: packages/email-hub/src/feature/pages/StarredPage.tsx
 * FILE_ID: EMAILHUB-FEATURE-PAGES-STARREDPAGE-001
 * PURPOSE: The Starred folder. Renders the SAME page as the Inbox
 *          (`InboxPage`) with `folder="starred"` — identical header
 *          chrome, list/reader split, auto-open first row and the full
 *          rich row toolkit. One frame, not a fork.
 * WHY:     Operator 2026-06-17: "copy the frame of inbox literally … we
 *          already have it." The old per-folder shell was a second,
 *          thinner layout that drifted from the Inbox (no auto-open, no
 *          filter chrome). One frame = no drift.
 * RELATED:
 *   - pages/InboxPage.tsx: the universal frame (accepts `folder`).
 *   - apps/<tenant>/src/features/email/pages/StarredPage.tsx: thin re-export.
 */

import InboxPage from './InboxPage'

export default function StarredPage() {
  return <InboxPage folder="starred" />
}
